import { render, staticRenderFns } from "./TechnologyList.vue?vue&type=template&id=22e84871&scoped=true&"
import script from "./TechnologyList.vue?vue&type=script&lang=ts&"
export * from "./TechnologyList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e84871",
  null
  
)

export default component.exports